import { OperatorRepositoryInterface } from "./OperatorRepositoryInterface";
import { BehaviorSubject, Observable } from "rxjs";
import { Operator } from "../model/Operator";
import { HttpClient } from "@angular/common/http";
import { User } from "../../user-management/model/User";
import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ConstantsService } from "../../../constants.service";

@Injectable({
  providedIn: 'root'
})
export class OperatorRepositoryApi implements OperatorRepositoryInterface {
  private apiUrl: string = "";
  private findAllOperatorsSubject: BehaviorSubject<Operator[]> | null = null;

  constructor(private http: HttpClient, private constantService: ConstantsService) {
    this.constantService.onReady(() => {
      this.apiUrl = this.constantService.getConstant('apiUrl');
    });
  }

  findAll(): Observable<Operator[]> {
    if (this.findAllOperatorsSubject === null) {
      this.findAllOperatorsSubject = new BehaviorSubject<Operator[]>([]);

      this.constantService.onReady(() => {
        this.http.get<User[]>(`${this.apiUrl}/user/api/v1/users/getUsers`, { withCredentials: true }).pipe(
          map((users: User[]) => users.map(user => new Operator(user.userId, user.name)))
        ).subscribe(operators => this.findAllOperatorsSubject?.next(operators));
      })
    }

    return this.findAllOperatorsSubject.asObservable();
  }
}
